import React, { useState, useEffect } from 'react';
import { useMessages } from '../../context/MessageContext';
import { Link, useLocation } from 'react-router-dom';
import Modal from "../../utils/modalUtils";
import authApiService from '../../services/authServices'


const InboxBoard = () => {
  const { privateMessages, fetchMessagesForProfile } = useMessages();
  const [selectedMessage, setSelectedMessage] = useState(null);
  const location = useLocation();
  const [selectedMessages, setSelectedMessages] = useState([]);


  useEffect(() => {
    fetchMessagesForProfile();
  }, []);

  useEffect(() => {
    const passedMessage = location.state?.message;
    if (passedMessage) {
      setSelectedMessage(passedMessage);
    }
  }, [privateMessages, location.state]);

  const handleMessageClick = (msg) => {
    setSelectedMessage(msg);
  };

  const formatDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return isNaN(d.getTime()) ? "N/A" : d.toISOString().split("T")[0];
  };


  // const handleCheckboxChange = (index) => {
  //   setSelectedMessages((prevSelected) => {
  //     if (prevSelected.includes(index)) {
  //       // If already selected, remove from array
  //       return prevSelected.filter((i) => i !== index);
  //     } else {
  //       // Otherwise, add to array
  //       return [...prevSelected, index];
  //     }
  //   });
  // };


  const handleCheckboxChange = (messageId) => {
    const id = Number(messageId);
    setSelectedMessages((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((selectedId) => selectedId !== id);
      }
      return [...prevSelected, id];
    });
  };

  /**
   * Handles deletion of selected messages with confirmation
   */
  const handleDelete = async () => {
    try {
      if (selectedMessages.length === 0) {
        Modal.fire({
          icon: "warning",
          title: "Warning",
          text: "Please select a message to delete.",
          confirmButtonText: "OK"
        });
        return;
      }

      const result = await Modal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#addd1e",
        cancelButtonColor: "#b38ec1",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel"
      });

      if (result.isConfirmed) {
        try {
          const payload = {
            id: selectedMessages.map((id) => Number(id)).filter((id) => Number.isInteger(id) && id > 0),
          };
          if (payload.id.length === 0) {
            Modal.fire({
              icon: "warning",
              title: "Warning",
              text: "Please select a message to delete.",
              confirmButtonText: "OK"
            });
            return;
          }

          const response = await authApiService.put("deletePrivateMessage", payload);

          if (response.code === 200) {
            const deletedIds = new Set(payload.id.map(String));
            if (selectedMessage && deletedIds.has(String(selectedMessage.id))) {
              setSelectedMessage(null);
            }
            setSelectedMessages([]);
            await fetchMessagesForProfile();
            Modal.fire({
              icon: "success",
              title: "Deleted!",
              text: "Message(s) deleted successfully.",
              confirmButtonText: "OK",
              confirmButtonColor: "#addd1e"
            });
          } else {
            Modal.fire({
              icon: "error",
              title: "Error",
              text: response?.message || "Failed to delete messages. Please try again.",
              confirmButtonText: "OK",
              confirmButtonColor: "#addd1e"
            });
          }
        } catch (error) {
          console.error('Error deleting messages:', error);
          Modal.fire({
            icon: "error",
            title: "Error",
            text: error.response?.data?.message || "Failed to delete messages. Please try again.",
            confirmButtonText: "OK",
            confirmButtonColor: "#addd1e"
          });
        }
      }
    } catch (error) {
      console.error('Error in handleDelete:', error);
    }
  };


  return (
    <div className="page-container col-sm-9">
      <style>{`
        #inboxboard .inbox-scroll {
          height: 240px;
          max-height: 240px;
          min-height: 240px;
          overflow-y: scroll;
          overflow-x: hidden;
        }
        #inboxboard .inbox-scroll::-webkit-scrollbar,
        #inboxboard #inbox-message #msg::-webkit-scrollbar {
          width: 8px;
        }
        #inboxboard .inbox-scroll::-webkit-scrollbar-track,
        #inboxboard #inbox-message #msg::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        #inboxboard .inbox-scroll::-webkit-scrollbar-thumb,
        #inboxboard #inbox-message #msg::-webkit-scrollbar-thumb {
          background: #444;
          border-radius: 4px;
        }
        #inboxboard table.messages tr {
          height: 48px;
        }
        #inboxboard table.messages tr.even {
          background: #dedfdd;
        }
        #inboxboard table.messages tr.odd {
          background: #fff;
        }
        #inboxboard table.messages {
          width: 100%;
          margin: 0;
        }
        #inboxboard {
          padding-bottom: 60px;
        }
        #inboxboard table.messages td {
          padding: 0 10px;
          height: 48px;
          line-height: 26px;
          box-sizing: border-box;
          vertical-align: middle;
          white-space: nowrap;
        }
        #inboxboard table.messages td.chk-col {
          width: 32px;
        }
        #inboxboard table.messages td.chk-col input {
          width: 16px;
          height: 16px;
          margin: 0;
        }
        #inboxboard .sender-name {
          color: #7a9234;
          font-weight: 600;
        }
        #inboxboard .subject-link {
          color: #7a9234;
          text-decoration: underline;
          cursor: pointer;
        }
        #inboxboard .msg-date {
          color: #777;
          text-align: left;
        }
        #inboxboard table.messages tr.inbox-row {
          cursor: pointer;
        }
        #inboxboard #inbox-message {
          margin-top: 8px;
        }
        #inboxboard #inbox-message .selected-msg-bar {
          display: flex;
          align-items: center;
          gap: 12px;
          background: #dedfdd;
              padding: 16px 12px;
              justify-content: space-between;
            margin: 20px 0;
        }
        #inboxboard #inbox-message .selected-msg-bar .from-text,
        #inboxboard #inbox-message .selected-msg-bar .subject-text {
          color: #7a9234;
          font-weight: 600;
          font-size: 15px;
        }
        #inboxboard #inbox-message .selected-msg-bar .subject-text {
          margin-left: 0;
        }
        #inboxboard #inbox-message .selected-msg-bar .msg-date {
          min-width: 70px;
        }
        #inboxboard #inbox-message .msg-head {
          color: #7a9234;
          padding: 10px 0 4px 0px;
          margin: 0;
          font-size: 15px;
        }
        #inboxboard #inbox-message #msg {
          background-color: #dedfdd;
          color: #636363;
          padding: 10px 12px !important;
          min-height: 206px;
          max-height: 206px;
          overflow-y: scroll;
          white-space: pre-wrap;
        }
          #inboxboard .msg-date, td.subject-link {
    text-align: right;
}
.selected-msg-bar-left input[type="checkbox"] {
    margin-right: 10px;
}
#inboxboard .msg-date {
    padding-left: 10px !important;
}
        #inboxboard #inbox-message a.reply-link {
          color: #cc0000;
          font-weight: 400;
          float: right;
          text-decoration: none;
          font-size: 16px;
          margin-top: 20px;
          padding: 8px 4px 20px 0;
        }
        #inboxboard #inbox-message::after {
          content: "";
          display: block;
          clear: both;
          height: 30px;
        }
        #inboxboard .inbox-delete-bar {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          padding: 8px 0 4px 0;
          margin-top: 24px;
          gap: 10px;
        }
        #inboxboard .inbox-delete-bar .selected-count {
          font-size: 13px;
          color: #777;
        }
        #inboxboard .inbox-delete-bar button.del-btn {
          font-size: 14px;
          margin-top: 0;
          background: #dddddb;
          color: #777078;
          display: inline-block;
          padding: 10px 40px;
          border-radius: 30px;
          text-decoration: none;
          border: none;
          cursor: pointer;
        }
        #inboxboard .inbox-delete-bar button.del-btn:hover {
          background: #c8c8c6;
          color: #555;
        }
      `}</style>
      <div className="msgboard-section" id="inboxboard">
        <div id="inbox" className="col-12">
          <div
            className="courts-page-heading"
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}
          >
            <h2 style={{ margin: 0 }}>Your Inbox</h2>
            <img
              src="/images/inbox.png"
              alt="Messages"
              style={{ width: 26, height: 26, objectFit: "contain" }}
            />
          </div>
          <div className="clear" />
          <form id="msgForm" onSubmit={(e) => e.preventDefault()}>
            <div className="shadow inbox-scroll">
              <table
                cellSpacing={0}
                id="message"
                className="messages"
                cellPadding={0}
              >
                <tbody>
                  {(() => {
                    const padded = [...privateMessages];
                    while (padded.length < 5) {
                      padded.push({ id: `empty-row-${padded.length}`, empty: true });
                    }
                    return padded.map((msg, index) => {
                      if (msg.empty) {
                        return (
                          <tr key={msg.id} className={index % 2 === 0 ? "even" : "odd"}>
                            <td className="chk-col" />
                            <td />
                            <td />
                            <td className="msg-date" />
                          </tr>
                        );
                      }
                      const messageId = Number(msg.id);
                      return (
                      <tr
                        key={messageId || index}
                        className={`${index % 2 === 0 ? "even" : "odd"} inbox-row`}
                        onClick={() => handleMessageClick(msg)}
                      >
                        <td className="chk-col" onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            onChange={() => handleCheckboxChange(messageId)}
                            checked={selectedMessages.includes(messageId)}
                          />
                        </td>
                        <td className="sender-name">{msg.sender || "Unknown Sender"}</td>
                        <td className="subject-link">
                          {msg.subject || "No Subject"}
                        </td>
                        <td className="msg-date">{formatDate(msg.sent || msg.date || msg.read_date)}</td>
                      </tr>
                      );
                    });
                  })()}
                </tbody>
              </table>
            </div>
            <div className="inbox-delete-bar">
              {selectedMessages.length > 0 && (
                <span className="selected-count">
                  {selectedMessages.length} selected
                </span>
              )}
              <button
                type="button"
                className="del-btn"
                onClick={handleDelete}
              >
                Delete
              </button>
            </div>
          </form>
        </div>
        {/* Display the selected message */}
        {selectedMessage && (
          <div id="inbox-message" className="col-12">
            <div className="selected-msg-bar">
              <div className="selected-msg-bar-left">
<input
                type="checkbox"
                onChange={() => handleCheckboxChange(Number(selectedMessage.id))}
                checked={selectedMessages.includes(Number(selectedMessage.id))}
              />
              <span className="from-text">
                From: {selectedMessage.sender || "Unknown Sender"}
              </span>

              </div>
              <div className="selected-msg-bar-right">
              <span className="subject-text">
                {/^\s*Re:/i.test(selectedMessage.subject || "") ? "" : "Subject: "}
                {selectedMessage.subject || "No Subject"}
              </span>
              <span className="msg-date">
                {formatDate(selectedMessage.sent || selectedMessage.date || selectedMessage.read_date)}
              </span>
              </div>
              
            </div>
            <div id="msg" className="msg-content">
              
            <div><span className="msg-head">Message:</span> {selectedMessage.message || "No content"}</div>
            </div>
            <Link
              to={`/carter/sendMessage?userId=${selectedMessage.senderId}`}
              className="reply-link"
              state={{ message: selectedMessage, recipientName: selectedMessage.sender }}
            >
              Reply
            </Link>
          </div>
        )}
        <div className="clear" />
      </div>
    </div>
  );
};

export default InboxBoard;